import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-border/30 mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col items-center space-y-3">
          {/* Copyright and Tagline */}
          <div className="text-center">
            <p className="text-textMuted text-sm">
              TypeRush © 2026
            </p>
            <p className="text-textMuted/70 text-xs mt-1">
              Speed. Precision. Mastery.
            </p>
          </div>
          
          {/* Links */}
          <div className="flex items-center space-x-6 text-sm">
            <Link 
              to="/about" 
              className="text-textMuted hover:text-accent transition-colors"
            >
              About
            </Link>
            <span className="text-textMuted/30">•</span>
            <Link 
              to="/privacy" 
              className="text-textMuted hover:text-accent transition-colors"
            >
              Privacy
            </Link>
            <span className="text-textMuted/30">•</span>
            <Link 
              to="/terms" 
              className="text-textMuted hover:text-accent transition-colors"
            >
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
